import { coreWalletTypeToResourceMapping } from 'cw-core-admin-ui/src/coreWalletTypes';

const demoWalletTypeToResourceMapping = {
	Purchase: 'purchases',
	ShopConfiguration: 'shopConfigurations',
	InvoiceVoucher: 'invoiceVouchers',
	LoyaltyProgram: 'loyaltyPrograms',
	LoyaltyProgramMembership: 'loyaltyProgramMemberships',
	LoyaltyCredit: 'loyaltyCredits',
	Marketplace: 'Marketplaces',
	MarketplaceSeller: 'MarketplaceSellers',
	MarketplacePurchase: 'MarketplacePurchases',
};

const mergedTypeMapping = {
	...coreWalletTypeToResourceMapping,
	...demoWalletTypeToResourceMapping,
};

export default mergedTypeMapping;
